import clsx from 'clsx';
import { useCallback } from 'react';

import { FormElementText } from '~components/generic/editor/FormElementText';
import useLabels from '~hooks/useLabels';
import { IEntityComponentProps } from '~interfaces/props';
import { Feed } from '~modules/newsfeed/Feed';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export default function ModuleNewsfeed({ data, editing, className, onChange }: IEntityComponentProps) {
  const { labelModuleNewsfeedTitle, placeholderModuleNewsfeedTitle } = useLabels([
    'labelModuleNewsfeedTitle',
    'placeholderModuleNewsfeedTitle',
  ]);

  const handleChange = useCallback(
    (fieldName: string) => (value: string) => {
      onChange(fieldName, value);
    },
    [onChange],
  );
  const handleTitleChange = handleChange('attributes.field_title.value');

  // Do not render if there is no data!
  if (!data) {
    return null;
  }

  // ClassName generation
  const clsModule = clsx({ ...className.module });
  const clsContainer = clsx('relative px-0', { ...className.container });

  // Get texts
  const fieldTitleValue: string = data.attributes.field_title?.value || '';

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsContainer}>
        {editing ? (
          <div className="row c-module__header">
            <div className="col u-margin-bottom-md">
              <div className="u-margin-vertical-sm">
                <FormElementText
                  value={fieldTitleValue}
                  onChange={handleTitleChange}
                  label={labelModuleNewsfeedTitle}
                  placeholder={placeholderModuleNewsfeedTitle}
                />
              </div>
            </div>
          </div>
        ) : (
          <Feed title={fieldTitleValue} />
        )}
      </div>
    </div>
  );
}
